<template>
		<transition name="el-fade-in">
			<div class="modal-bg " v-show="show">
				<div class="modal-container modal_efect" :style="getStyle">
					<div class="modal-header">
						<div class="left" v-if="cooperativeTypes && cooperativeTypes.length >= 1">
							<img :src="require(`@/assets/images/cooperative/cooperativeIcon/type_${item}.png`)" v-for="item in cooperativeTypes"/>
						</div>
						<div v-else></div>
						<div class="right" @click="close" v-if="showColse">
							<img class="close" src="../assets/images/home/icon_close.png" alt="" srcset="">
						</div>
					</div>
					<div class="modal-main">
						<slot name="content"></slot>
					</div>
					<div class="modal-footer" v-if="$slots.footer">
						<slot name="footer"></slot>
					</div>
				</div>
			</div>
		</transition>
</template>

<script>
	export default {
		name: 'modal',
		props: {
			/** 弹框宽度 */
			width:{
				type:String,
				default:'24.1vw'
			},
			/** 显示弹框 */
			show: {
				type: Boolean,
				default: false
			},
			/** 标题 */
			title: {
				type: String,
				default: '详情'
			},
			/** 显示关闭按钮 */
			showColse: {
				type: Boolean,
				default: true
			},
			/** 样式 */
			setStyle: {
				type: [Object, Array],
				default() {
					return {}
				}
			},
			// 合作社类型
			cooperativeTypes: {
				type: Array,
				default() {
					return []
				}
			}
		},
		computed: {
			getStyle() {
				return {
					width: this.width,
					...this.setStyle
				}
			},
		},
		methods: {
			close() {
				this.$emit('close')
			},


		}
	}
</script>

<style lang="scss" scoped>
	@function vw($px) {
	  @return ($px / 1920) * 100vw;
	}
	@function vh($px) {
	  @return ($px / 1080) * 100vh;
	}
	@function fontSize($px) {
		@return 100vw * $px / 1920;
	}
	.modal-bg {
		position: relative;
		transition: display 2000ms;
		/* position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, .5);
		z-index: 10; */
	}
	
.modal-del{
	position:absolute ;
	right:vh(19) ;
	height:vw(10);
}
.close {
	width: vw(20);
	height: vh(20);
	cursor: pointer;
}
	.modal_efect {
	

		padding: vw(20) vh(80);
		width: vw(466);
	}

	.modal-container {
		border-radius: 10px;
		overflow: hidden;
		position: fixed;
		top: 50%;
		left: 50%;
		z-index: 100;
		transform: translate(-50%, -50%);
	}

	.modal-header {
		height: vh(36);
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 vh(12) 0 0;
		.right{
			width: vw(20);
			height: vh(20);
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 50%;
		}
		.left{
			display: flex;
			padding: vh(8) vw(7);
			height: 100%;
			background: #195D3C;
			opacity: 0.8;
			border: 1px solid #87FFC5;
			border-top-left-radius: vw(10);
			border-top-right-radius: vw(10);
			font-size: fontSize(16);
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #FFFFFF;
			img {
				margin: 0 vw(6);
			}
		}
	}

	.modal-footer {
		display: flex;
		align-items: center;
		justify-content: center;
		height: vh(57);
		background: rgba(10,77,19,0.8);
	}

	.modal-footer button {
		width: vw(100);
	}

	.modal-main {
		//padding: 15px 40px;
		background: rgba(25, 93, 60, 0.9);
		padding:vh(12) vw(12);
		max-height: vh(800);
		box-shadow: 2px 3px 5px #0DFFA9;
		/* 谷歌美化滚动条 */
		&::-webkit-scrollbar {
				width: 6px;
				height: 6px;
		}
		&::-webkit-scrollbar-track {
				background: rgba(10, 77, 19, 0.2);
				border-radius: 2px;
		}
		&::-webkit-scrollbar-thumb {
				background: rgba(48, 234, 168, 0.6);
				border-radius: 10px;
		}
		&::-webkit-scrollbar-thumb:hover {
				background: rgba(48, 234, 168,0.8);
		}
		&::-webkit-scrollbar-corner {
				background: rgba(48, 234, 168, 0.6);
		}
		/* 火狐美化滚动条 */
		.el-dialog__body {
				scrollbar-color: rgba(48, 234, 168, 0.6) rgba(10, 77, 19, 0.2);
				/* 滑块颜色  滚动条背景颜色 */
				scrollbar-width: thin;
				/* 滚动条宽度有三种：thin、auto、none */
		}
	}
</style>
